// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-text {
  color: black;
}

.info-text-medium {
  font-size: var(--font-size-medium) !important;
}

.info-text-small {
  font-size: var(--font-size-small) !important;
}

.selected-item {
  --background: rgba(var(--ion-color-primary-rgb), 0.08) !important;
}

.pilot-list-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  border-radius: 5px;
}

.pilot-list-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 5px;
}

.pilot-list-title-col {
  display: flex;
  flex-direction: column;
}

.pilot-item {
  --border-style: solid;
  --border-width: 2px;
  --border-color: transparent;
  --border-radius: 6px;
  transition: --border-color 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 4px;
}
.pilot-item:hover {
  --border-color: var(--ion-color-primary);
  box-shadow: var(--shadow-primary-sm);
}
.pilot-item.selected-item {
  --border-color: var(--ion-color-primary);
  box-shadow: var(--shadow-primary-sm);
}

.actions-fab-col {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: right;
}

.create-fab {
  margin: 5px 0;
}
.create-fab ion-fab-button {
  width: 100%;
  height: 100%;
}
.create-fab ion-icon {
  width: 50%;
  height: 50%;
}

.pilot-list-row {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
}

.pilots-list {
  height: 100%;
  width: 100%;
  overflow-y: auto;
}

.pilots-list-item {
  display: flex;
  flex-direction: column;
  width: 100%;
}

ion-item {
  --padding-start: 2px;
  --padding-end: 2px;
  --inner-padding-end: 0px;
  --inner-padding-start: 0px;
}

.pilot-item-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 5px;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.item-icon {
  flex: 0 0 auto;
  width: var(--icon-size-medium);
  height: var(--icon-size-medium);
  color: var(--ion-color-medium);
  cursor: pointer;
}

.icon-end {
  margin-left: auto;
  padding-right: 1vw;
}

.icon-start {
  margin-right: 1vw;
  padding-left: 1vw;
}

.pilotIcon {
  width: var(--icon-size-xx-large);
  height: var(--icon-size-xx-large);
  flex: 0 0 auto;
}

.avatar-image {
  width: 100%;
  height: 100%;
}

.item-info-col {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  margin-left: 1vw;
  justify-content: center;
  align-items: left;
}
.item-info-col ion-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  .create-fab {
    width: 25px;
    height: 25px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  .create-fab {
    width: 35px;
    height: 35px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  .create-fab {
    width: 45px;
    height: 45px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/fleet/components/pilot-list/pilot-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA;EACE,iEAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,0DAAA;EACA,kBAAA;AACF;AACE;EACE,wCAAA;EACA,oCAAA;AACJ;AAEE;EACE,wCAAA;EACA,oCAAA;AAAJ;;AAIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EAEE,aAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,UAAA;EACA,WAAA;AAHJ;;AAOA;EACE,aAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;AAJF;;AAOA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAJF;;AAOA;EACE,oBAAA;EACA,kBAAA;EACA,wBAAA;EACA,0BAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAJF;;AAQA;EACE,cAAA;EACA,8BAAA;EACA,+BAAA;EACA,8BAAA;EACA,eAAA;AALF;;AAQA;EACE,iBAAA;EACA,kBAAA;AALF;;AAQA;EACE,iBAAA;EACA,iBAAA;AALF;;AAQA;EACE,gCAAA;EACA,iCAAA;EAEA,cAAA;AANF;;AAUA;EACE,WAAA;EACA,YAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAPF;AASE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAPJ;;AAWA,sEAAA;AAEE,wBAAA;AAEE,2DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAVN;AACF;AAaE,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAbN;AACF;AAgBE,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAhBN;AACF;AAmBE,4BAAA","sourcesContent":[".title-text {\r\n  color: black;\r\n}\r\n\r\n.info-text-medium {\r\n  font-size: var(--font-size-medium) !important;\r\n}\r\n\r\n.info-text-small {\r\n  font-size: var(--font-size-small) !important;\r\n}\r\n\r\n.selected-item {\r\n  --background: rgba(var(--ion-color-primary-rgb), 0.08) !important;\r\n}\r\n\r\n.pilot-list-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.pilot-list-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 10px;\r\n  gap: 5px;\r\n}\r\n\r\n.pilot-list-title-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.pilot-item {\r\n  --border-style: solid;\r\n  --border-width: 2px;\r\n  --border-color: transparent;\r\n  --border-radius: 6px;\r\n  transition: --border-color 0.2s ease, box-shadow 0.2s ease;\r\n  margin-bottom: 4px;\r\n\r\n  &:hover {\r\n    --border-color: var(--ion-color-primary);\r\n    box-shadow: var(--shadow-primary-sm);\r\n  }\r\n\r\n  &.selected-item {\r\n    --border-color: var(--ion-color-primary);\r\n    box-shadow: var(--shadow-primary-sm);\r\n  }\r\n}\r\n\r\n.actions-fab-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: right;\r\n}\r\n\r\n.create-fab {\r\n\r\n  margin: 5px 0;\r\n\r\n  ion-fab-button {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  ion-icon {\r\n    width: 50%;\r\n    height: 50%;\r\n  }\r\n}\r\n\r\n.pilot-list-row {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  width: 100%;\r\n}\r\n\r\n.pilots-list {\r\n  height: 100%;\r\n  width: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.pilots-list-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\nion-item {\r\n  --padding-start: 2px;\r\n  --padding-end: 2px;\r\n  --inner-padding-end: 0px;\r\n  --inner-padding-start: 0px;\r\n}\r\n\r\n.pilot-item-row {\r\n  display:flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  padding: 5px;\r\n  align-items: center;\r\n  width: 100%;\r\n  min-width: 0;\r\n\r\n}\r\n\r\n.item-icon {\r\n  flex: 0 0 auto;\r\n  width: var(--icon-size-medium);\r\n  height: var(--icon-size-medium);\r\n  color: var(--ion-color-medium);\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-end {\r\n  margin-left: auto;\r\n  padding-right: 1vw;\r\n}\r\n\r\n.icon-start {\r\n  margin-right: 1vw;\r\n  padding-left: 1vw;\r\n}\r\n\r\n.pilotIcon {\r\n  width: var(--icon-size-xx-large);\r\n  height: var(--icon-size-xx-large);\r\n\r\n  flex: 0 0 auto;\r\n\r\n}\r\n\r\n.avatar-image {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.item-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  margin-left: 1vw;\r\n  justify-content: center;\r\n  align-items: left;\r\n\r\n  ion-label {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n  /*#region Small Screens*/\r\n\r\n    /* Styles for screens smaller than 800px wide or 550 high */\r\n    @media (max-width: 599px) {\r\n      .create-fab {\r\n        width: 25px;\r\n        height: 25px;\r\n      }\r\n    }\r\n\r\n  /*#endregion Small Screens*/\r\n\r\n  /*#region Medium Screens*/\r\n\r\n    /* Styles for medium screens with min with of 800px and min height of 550px */\r\n    @media (min-width: 600px) and (max-width: 1023px) {\r\n      .create-fab {\r\n        width: 35px;\r\n        height: 35px;\r\n      }\r\n    }\r\n\r\n  /*#endregion Medium Screens*/\r\n\r\n  /*#region Larger Screens*/\r\n\r\n    /* Styles for screens larger than 1000px wide and 600px high */\r\n    @media (min-width: 1024px) {\r\n      .create-fab {\r\n        width: 45px;\r\n        height: 45px;\r\n      }\r\n    }\r\n\r\n  /*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
